import React, { useEffect, useRef, useState } from "react";
import Container from "../../utils/Container";
import logo from "../../assets/logo/logo.svg";
import { Link, useLocation, useNavigate } from "react-router-dom";
import userImage from "../../assets/icons/user.png";
import { useAuth } from "../../utils/useAuth";
import { VscDashboard } from "react-icons/vsc";
import { BiWorld } from "react-icons/bi";
import { FaSignOutAlt, FaUser } from "react-icons/fa";
import { secureStorage } from "../../utils/secureStorage";
import { gsap } from "gsap";
const Header = () => {
  const [HidenMenu, setHidenMenu] = useState(false);
  const navigate = useNavigate();
  const { user, isLoggedIn } = useAuth();
  const location = useLocation();
  const logoRef = useRef();
  const menuRef = useRef();
  const actionBtnRef = useRef();
  useEffect(() => {
    const tl = gsap.timeline();
    tl.from(logoRef.current, {
      opacity: 0,
      y: -80,
      duration: 0.5,
      delay: 0.5,
    });
    tl.from(
      menuRef.current.querySelectorAll("a"),
      {
        y: -120,
        duration: 0.5,
        stagger: 0.3,
      },
      ">",
    );
    tl.from(
      actionBtnRef.current,
      {
        opacity: 0,
        y: -80,
        duration: 0.5,
      },
      ">",
    );
  }, []);
  useEffect(() => {
    const onScroll = () => {
      if (window.scrollY.toFixed(0) > 16) {
        setHidenMenu(true);
      } else {
        setHidenMenu(false);
      }
    };
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  const handleLoginNext = () => {
    if (!isLoggedIn) {
      navigate("/authentication/signin");
    }
  };
  const handleLogout = () => {
    secureStorage.removeItem("accessToken");
    secureStorage.removeItem("user");
    navigate("/");
  };
  return (
    <div
      className={`mainHeader hidden lg:block bg-white bg-clip-padding backdrop-filter backdrop-blur-2xl bg-opacity-10 py-4 ${
        HidenMenu ? "fixed lg:sticky w-full" : "sticky"
      }  top-0 z-30`}
    >
      <Container>
        <div className="grid grid-cols-1 lg:grid-cols-3 items-center gap-y-4 lg:gap-y-0 ">
          <div className="justify-self-center lg:justify-self-start">
            <Link to="/">
              <img
                ref={logoRef}
                className={`w-[120px] lg:w-[180px]`}
                width={HidenMenu ? 120 : 180}
                src={logo}
                alt="dhoorbin.com"
              />
            </Link>
          </div>
          <div
            className={`justify-self-center ${
              HidenMenu ? "hidden lg:block" : ""
            }`}
          >
            <div ref={menuRef} className="flex space-x-4">
              <Link to="/">
                <div
                  className={`px-4 lg:px-4 py-1 lg:py-2 rounded-full ${
                    location.pathname === "/"
                      ? "bg-[#153875] text-white"
                      : "bg-gray-200"
                  } text-xs lg:text-sm  cursor-pointer`}
                >
                  Hotel
                </div>
              </Link>
              <Link to={"/tours"}>
                <div
                  className={`px-4 lg:px-4 py-1 lg:py-2 rounded-full text-xs ${
                    location.pathname === "/tours"
                      ? "bg-[#153875] text-white"
                      : "bg-gray-200"
                  } lg:text-sm cursor-pointer`}
                >
                  Tours
                </div>
              </Link>
              <Link to={"/offers"}>
                <div
                  className={`px-4 lg:px-4 py-1 lg:py-2 rounded-full text-xs ${
                    location.pathname === "/offers"
                      ? "bg-[#153875] text-white"
                      : "bg-gray-200"
                  } lg:text-sm cursor-pointer`}
                >
                  Offers
                </div>
              </Link>
            </div>
          </div>
          <div className="relative justify-self-end group hidden sm:flex space-x-4">
            <button
              ref={actionBtnRef}
              onClick={handleLoginNext}
              className="w-12 h-12 overflow-hidden rounded-full"
            >
              <img src={userImage} alt="" />
            </button>

            {isLoggedIn && (
              <div className="absolute top-full right-0 mt-0 w-[200px] p-3 border rounded-lg bg-white shadow-md opacity-0 pointer-events-none transition-opacity duration-200 group-hover:opacity-100 group-hover:pointer-events-auto z-50">
                <div className="space-y-3">
                  <div
                    onClick={() => navigate("/customer/dashboard")}
                    className="flex justify-start items-center gap-1 p-1 text-sm text-black/70 bg-white hover:bg-[#d5e2f8] duration-300 rounded-lg hover:font-bold cursor-pointer"
                  >
                    <VscDashboard />
                    <p>Dashboard</p>
                  </div>
                  <div
                    onClick={() => navigate("/customer/dashboard")}
                    className="flex justify-start items-center gap-1 p-1 text-sm text-black/70 bg-white hover:bg-[#d5e2f8] duration-300 rounded-lg hover:font-bold cursor-pointer"
                  >
                    <BiWorld />
                    <p>My Booking</p>
                  </div>
                  <div
                    onClick={() => navigate("/customer/dashboard")}
                    className="flex justify-start items-center gap-1 p-1 text-sm text-black/70 bg-white hover:bg-[#d5e2f8] duration-300 rounded-lg hover:font-bold cursor-pointer"
                  >
                    <FaUser />
                    <p>My Profile</p>
                  </div>
                  <div
                    onClick={handleLogout}
                    className="flex justify-start items-center gap-1 p-1 text-sm text-black/70 bg-white hover:bg-[#d5e2f8] duration-300 hover:text-red-500 rounded-lg hover:font-bold cursor-pointer"
                  >
                    <FaSignOutAlt />
                    <p>Logout</p>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </Container>
    </div>
  );
};

export default Header;
